import { GridCell } from '@progress/kendo-react-grid'
import React from 'react'
import { Link } from '../../../components/link'
import * as Menu from '../../../components/menu/constants'

export class LinkReportsCell extends GridCell {
  public render() {
    return <td>
      <Link
        className="secondary-button"
        href={`${Menu.INTEGRATION_REPORTS_URL}/${this.props.dataItem.id}`}>
          View
      </Link>
    </td>}
}



// WEBPACK FOOTER //
// ./src/pages/integrations/render/link_reports_cell.tsx